import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { DemographicSocioeconomicGroup } from '@/core/api/entities/demographicSocioeconomicGroup'
import { DemographicSocioeconomicGroupMapper } from '@/core/api/mappers/demographicSocioeconomicGroupMapper'
import demographicSocioeconomicGroupService from '@/core/api/services/demographicSocioeconomicGroupService'

export const useDemographicSocioeconomicGroups = ({
	config,
	options,
}: any = {}): UseQueryResult<DemographicSocioeconomicGroup[], Error> => {
	const QUERY_KEY = [
		'demographic_socioeconomic_groups',
		{
			...config?.params,
		},
	]

	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: () =>
			demographicSocioeconomicGroupService
				.getDemographicSocioeconomicGroups(config)
				.then(({ data }) => {
					return DemographicSocioeconomicGroupMapper.toEntities(data.data)
				}),
		...options,
		cacheTime: 86400000, // 24h = 24h * 60m * 60s * 1000ms = 86400000ms
		staleTime: 86400000, // 24h = 24h * 60m * 60s * 1000ms = 86400000ms
	})
}
